<div class="print-panel__content">
  <button class="text-button print-panel__button" (click)="requestPrintBlank()"><span class="text-button__icon icon icon-paper"></span><span class="text-button__label">{{ 'cfg_printBlankPage' | translate | brand }}</span></button>
  <button class="text-button print-panel__button" (click)="requestPrintElba()"><span class="text-button__icon icon icon-text-document"></span><span class="text-button__label">{{ 'cfg_printElbaPage' | translate | brand }}</span></button>
  <button class="text-button print-panel__button" (click)="calibrate()"><span class="text-button__icon icon icon-calibrate"></span><span class="text-button__label">{{ 'cfg_calibrate_printer' | translate | brand }}</span></button>
</div>

<div class="print-panel__infos" [innerHTML]="'cfg_calibrationInfo' | translate | replace:{ h: printService.hPrintOffset, v: printService.vPrintOffset }"></div>

<app-modal id="modal-print-advice" width="640" [blocking]="false" #mpa>
  <div class="print-advice">
    <div class="print-advice__title">
      {{ 'cfg_printWarning_title' | translate }}
    </div>
    <div class="print-advice__content">
      <div class="print-advice__subtitle">
        {{ 'cfg_printWarning_subtitle_1' | translate }}
      </div>
      <div class="print-advice__text" [innerHTML]="'cfg_printWarning_text_1' | translate">
      </div>
    </div>
    <div class="print-advice__content">
      <div class="print-advice__subtitle">
        {{ 'cfg_printWarning_subtitle_2' | translate }}
      </div>
      <div class="print-advice__text" [innerHTML]="'cfg_printWarning_text_2' | translate">
      </div>
    </div>
    <button class="button button--square" (click)="mpa.data.func()">
      <span>{{ 'btn_validate' | translate }}</span>
    </button>
  </div>
</app-modal>


<app-modal id="modal-print-calibration" width="640" [blocking]="false" #mpc>
  <div class="print-calibration">
    <div class="print-calibration__title">
      {{ 'cfg_calibrate_printer' | translate }}
    </div>
    <div class="print-calibration__content">
      <div class="print-calibration__subtitle">
        <span class="print-calibration__bullet">1</span> {{ 'cfg_printWarning_subtitle_2' | translate }}
      </div>
      <a class="button--accent--outline button--square" target="_blank" [href]="'/assets/pdf/ELBA_Calibrage_@lang@.pdf' | brand | replace:{lang:langCode}">{{ 'cfg_calibrate_print_page' | translate }}</a>
      <div class="print-calibration__text" [innerHTML]="'cfg_printWarningText' | translate">
      </div>
    </div>
    <div class="print-calibration__content">
      <div class="print-calibration__subtitle">
          <span class="print-calibration__bullet">2</span> {{ 'cfg_calibrate_follow' | translate }}
      </div>
    </div>
    <div class="print-calibration__content">
      <div class="print-calibration__subtitle">
        <span class="print-calibration__bullet">3</span> {{ 'cfg_calibrate_enter' | translate }}
      </div>
      

      <div class="print-calibration__text inputs">
        <label for="vCalibInput">{{ 'cfg_calibrate_vertical' | translate }} :</label>
        <input type="number" id="vCalibInput" [class.error]="vCalibInputError" [(ngModel)]="vCalibInput"/>
        <span>{{ 'cfg_mm' | translate }}</span>
      </div>
      <div class="print-calibration__text inputs">
        <label for="hCalibInput">{{ 'cfg_calibrate_horizontal' | translate }} :</label>
        <input type="number" id="hCalibInput" [class.error]="hCalibInputError" [(ngModel)]="hCalibInput"/>
        <span>{{ 'cfg_mm' | translate }}</span>
      </div>
    </div>
    <button class="button button--square" (click)="submitCalibrationInput()">
      <span>{{ 'btn_validate' | translate }}</span>
    </button>
  </div>
</app-modal>

<app-modal id="modal-overlapse-control" width="640" [blocking]="true" #moc>
  <p [innerHtml]="'cfg_verificationInfo' | translate"></p>
  <p>{{ overlapseControlProgress }}</p>
</app-modal>

<app-modal id="modal-overlapse-results" width="640" [blocking]="true" #mor>
  <div class="print-overlapse-results">
      <div class="print-overlapse-results__title">{{ 'cfg_overlapsDetection_title' | translate }}</div>
      
      <div class="print-overlapse-results__content">
        <div class="print-overlapse-results__subtitle">{{ 'cfg_overlapsDetection_msg' | translate }}</div>
        <ul>
          <li *ngFor="let labelIndex of labelWithOverlaps">
            {{'cfg_overlapsDetection_indexPreffix' | translate | replace:{'i':(labelIndex+1)} }}
            <button class="round-button" (click)="goLabel(labelIndex)"><span class="round-button__icon icon icon-eye"></span></button>
          </li>
        </ul>
      </div>

      <button class="button button--square" (click)="mor.data.onIgnore()">
        <span>{{ 'btn_ignoreAndPrint' | translate }}</span>
      </button>
  </div>
</app-modal>